import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, Mail, Phone } from 'lucide-react';
import { BusinessHours } from './BusinessHours';
import { directionsUrl, EMAIL, locations, navLinks } from '../data/site';

const Footer = () => (
  <footer className="site-footer" data-testid="site-footer">
    <div className="site-container">
      <div className="footer-intro">
        <p className="footer-slogan" data-testid="footer-slogan">WE KEEP EL PASO <span>MOVING.</span></p>
        <p>Your trusted partner for exceptional auto repair services. We provide top-quality maintenance and repairs to keep your vehicle running smoothly.</p>
      </div>
      <div className="footer-grid">
        {locations.map((location) => <section key={location.id} data-testid={`footer-location-${location.id}`}>
          <h2>{location.name}</h2>
          <a className="footer-address" href={directionsUrl(location)} target="_blank" rel="noopener noreferrer" data-testid={`footer-directions-${location.id}`}>
            <span>{location.address}<br />{location.city}</span><ArrowUpRight size={17} aria-hidden="true" />
          </a>
          <a href={location.tel} className="footer-contact-link" data-testid={`footer-phone-${location.id}`}><Phone size={15} aria-hidden="true" />{location.phone}</a>
          <a href={`mailto:${EMAIL}`} className="footer-contact-link" data-testid={`footer-email-${location.id}`}><Mail size={15} aria-hidden="true" /><span>{EMAIL}</span></a>
        </section>)}
        <section><h2>Shop hours</h2><BusinessHours testId="footer-hours" /><p className="footer-timezone">Both locations · Mountain Time</p></section>
        <section><h2>Our services</h2><ul className="footer-services" data-testid="footer-services">
          {['Oil Change', 'Brake Repair', 'Tire Rotation', 'Engine Diagnostics', 'Battery Replacement', 'Maintenance Services'].map((service) => <li key={service}>{service}</li>)}
        </ul></section>
      </div>
      <nav className="footer-navigation" aria-label="Footer navigation">{navLinks.map((link) => <Link key={link.id} to={link.path} data-testid={`footer-nav-${link.id}`}>{link.name}</Link>)}</nav>
      <div className="footer-bottom"><p data-testid="footer-copyright">© {new Date().getFullYear()} Performance Lube 915. All rights reserved.</p><span>El Paso, Texas</span></div>
    </div>
  </footer>
);
export default Footer;